import Typography from "@anwb/typography";
import { DateTime } from "luxon";
import { DefaultDetails, TypedStatusUpdateMessage } from "@status-updates/types";
import { FrontendState, StateMetadata } from "../frontend-state";

export class ServiceStartedState extends FrontendState<DefaultDetails> {
  constructor(message: TypedStatusUpdateMessage<DefaultDetails>, metadata: StateMetadata) {
    super(message, metadata, {
      illustration: "alarmcentrale",
      title: `We zijn voor ${metadata.contractMarket === "coma" ? "je" : "u"} bezig`,
    });
  }

  renderTimelineItems() {
    return [
      {
        timestamp: DateTime.fromISO(this.message.created),
        title: this.options.title,
        content: (
          <Typography data-e2e-test-type="status-updates-service-started" tagName="div">
            Onze partner stuurt een hulpdienst naar {this.getInformalOrFormal("jou", "u")} toe. Zorg
            dat {this.getInformalOrFormal("je", "u")} bereikbaar blijft. Zodra wij meer weten, krijg{" "}
            {this.getInformalOrFormal("je", "u")} van ons een nieuw bericht.
          </Typography>
        ),
        feedback: this.renderFeedback(),
      },
    ];
  }
}
